/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs.js'

const $nsid = 'chat.bsky.convo.addReaction'

export { $nsid }

/** Adds an emoji reaction to a message. Requires authentication. It is idempotent, so multiple calls from the same user with the same emoji result in a single reaction. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    convoId: l.string(),
    messageId: l.string(),
    value: l.string({
      minLength: 1,
      maxLength: 64,
      minGraphemes: 1,
      maxGraphemes: 1,
    }),
  }),
  l.jsonPayload({
    message: l.ref<ConvoDefs.MessageView>((() => ConvoDefs.messageView) as any),
  }),
  ['ReactionMessageDeleted', 'ReactionLimitReached', 'ReactionInvalidValue'],
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
